module.exports = __webpack_public_path__ + "assets/3-NYC-Tech-Sales-Recruiters.33a4e73e.png";